<template>
  <div
    class="modal fade"
    id="editShopperDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form id="shopperEditForm">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <h4 class="modal-title">
              <b>{{ dialogTitle }}</b>
            </h4>

            <div v-if="editShopperData.ShopperId">
              <label class="control-label"
                >ID: {{ editShopperData.ShopperId }}, {{ lang.SM1048 }}:
                {{ editShopperData.Username }}</label
              >
            </div>
          </div>
          <div class="modal-body">
            <div
              class="panel-group"
              id="accordion"
              role="tablist"
              aria-multiselectable="true"
            >
              <div class="panel panel-default">
                <!-- Accordion entry 1 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingGeneral"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseGeneral"
                  aria-expanded="true"
                  aria-controls="collapseGeneral"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.SM1002 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseGeneral"
                  class="panel-collapse collapse in"
                  role="tabpanel"
                  aria-labelledby="headingGeneral"
                >
                  <div class="panel-body">
                    <div
                      id="profilePictureContainer"
                      class="col-md-3 col-md-push-9"
                      @click="openFileSelector()"
                    >
                      <img
                        v-if="editShopperData.ProfilePictureGuid"
                        :src="
                          '/api/download/' + editShopperData.ProfilePictureGuid
                        "
                      />
                      <img v-else src="/static/avatar.png" />
                      <input
                        id="inputShopperProfilePictureFile"
                        class="form-control hidden"
                        type="file"
                        accept="image/*"
                        @change="onShopperProfilePictureFileChange"
                        @click.stop
                      />
                      <a
                        role="button"
                        id="removeProfilePictureButton"
                        v-show="editShopperData.ProfilePictureGuid"
                        @click.stop="removeShopperProfilePictureFile()"
                      >
                        <i class="material-icons">clear</i>
                      </a>
                    </div>
                    <div class="form-group col-md-9 col-md-pull-3">
                      <label
                        for="inputShopperSalutation"
                        class="col-md-4 control-label"
                        >{{ lang.SM1003 }}</label
                      >
                      <div class="col-md-8">
                        <select
                          class="form-control"
                          id="inputShopperSalutation"
                          v-model="editShopperData.Salutation"
                        >
                          <option value>{{ lang.SM1004 }}</option>
                          <option value="F">{{ lang.SM1005 }}</option>
                          <option value="M">{{ lang.SM1006 }}</option>
                        </select>
                        <span
                          v-show="inputHasError('inputShopperSalutation')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group col-md-9 col-md-pull-3 noclearfix">
                      <label
                        for="inputShopperFirstName"
                        class="col-md-4 control-label"
                        >{{ lang.SM1010 }} *</label
                      >
                      <div class="col-md-8">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperFirstName"
                          v-model="editShopperData.FirstName"
                          @change="validateInput('inputShopperFirstName')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperFirstName')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group col-md-9 col-md-pull-3 noclearfix">
                      <label
                        for="inputShopperLastName"
                        class="col-md-4 control-label"
                        >{{ lang.SM1011 }} *</label
                      >
                      <div class="col-md-8">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperLastName"
                          v-model="editShopperData.LastName"
                          @change="validateInput('inputShopperLastName')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperLastName')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group col-md-9 col-md-pull-3 noclearfix">
                      <label
                        for="inputShopperGender"
                        class="col-md-4 control-label"
                        >{{ lang.SM1029 }} *</label
                      >
                      <div class="col-md-8">
                        <select
                          class="form-control"
                          id="inputShopperGender"
                          v-model="editShopperData.Gender"
                          @change="validateInput('inputShopperGender')"
                          required
                        >
                          <option value disabled hidden>
                            {{ lang.SM1004 }}
                          </option>
                          <option value="F">{{ lang.SM1031 }}</option>
                          <option value="M">{{ lang.SM1030 }}</option>
                          <option value="D">{{ lang.SM1033 }}</option>
                        </select>
                        <span
                          v-show="inputHasError('inputShopperGender')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group clearfix">
                      <label
                        for="inputShopperAddress1"
                        class="col-md-3 control-label"
                      >
                        {{ lang.SM1012 }}
                        <span v-if="!feature.isAudiTarget">*</span>
                      </label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperAddress1"
                          v-model="editShopperData.Address1"
                          @change="validateInput('inputShopperAddress1')"
                          :required="!feature.isAudiTarget"
                        />
                        <span
                          v-show="inputHasError('inputShopperAddress1')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperPostalCode"
                        class="col-md-3 control-label"
                        >{{ lang.SM1013 }} *</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperPostalCode"
                          v-model="editShopperData.PostalCode"
                          @change="validateInput('inputShopperPostalCode')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperPostalCode')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperCity"
                        class="col-md-3 control-label"
                        >{{ lang.SM1014 }} *</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperCity"
                          v-model="editShopperData.City"
                          @change="validateInput('inputShopperCity')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperCity')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperCountryCode"
                        class="col-md-3 control-label"
                        >{{ lang.SM1015 }} *</label
                      >
                      <div class="col-md-9">
                        <select2
                          class="form-control"
                          id="inputShopperCountryCode"
                          v-model="editShopperData.CountryCode"
                          :placeholder="lang.SM1004"
                          @change="validateInput('inputShopperCountryCode')"
                          required
                        >
                          <option></option>
                          <option
                            v-for="(country, ISOCode) in globals.countryList"
                            :key="ISOCode"
                            :value="ISOCode"
                          >
                            {{ country }}
                          </option>
                        </select2>
                      </div>
                      <span
                        v-show="inputHasError('inputShopperCountryCode')"
                        class="help-block error text-danger"
                        >{{ lang.SM1009 }}</span
                      >
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperBirthdate"
                        class="col-md-3 control-label"
                        >{{ lang.SM1016 }} *</label
                      >
                      <div
                        class="col-md-9"
                        @click="
                          globals.toggleFlatpickr('inputShopperBirthdate')
                        "
                      >
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperBirthdate"
                          v-model="editShopperData.Birthdate"
                          @change="validateInput('inputShopperBirthdate')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputShopperBirthdate')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperEmail"
                        class="col-md-3 control-label"
                      >
                        {{ lang.SM1017 }}
                        <span v-if="!feature.isAudiTarget">*</span>
                      </label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperEmail"
                          v-model="editShopperData.Email"
                          @change="validateInput('inputShopperEmail')"
                          :required="!feature.isAudiTarget"
                        />
                        <span
                          v-show="inputHasError('inputShopperEmail')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperPhone1"
                        class="col-md-3 control-label"
                      >
                        {{ lang.SM1018 }}
                        <span v-if="!feature.isAudiTarget">*</span>
                      </label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperPhone1"
                          v-model="editShopperData.Phone1"
                          @change="validateInput('inputShopperPhone1')"
                          :required="!feature.isAudiTarget"
                        />
                        <span
                          v-show="inputHasError('inputShopperPhone1')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperPhone2"
                        class="col-md-3 control-label"
                        >{{ lang.SM1019 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperPhone2"
                          v-model="editShopperData.Phone2"
                        />
                      </div>
                    </div>
                    <div class="form-group" v-if="!feature.isAudiTarget">
                      <label
                        for="inputShopperOccupationGroup"
                        class="col-md-3 control-label"
                        >{{ lang.SM1020 }} *</label
                      >
                      <div class="col-md-9">
                        <select2
                          class="form-control"
                          id="inputShopperOccupationGroup"
                          v-model="editShopperData.OccupationalGroupGuid"
                          :placeholder="lang.SM1004"
                          @change="validateInput('inputShopperOccupationGroup')"
                          required
                        >
                          <option></option>
                          <option
                            v-for="(occupationGroup,
                            occupationGroupGuid) in occupationalGroupList"
                            :key="occupationGroupGuid"
                            :value="occupationGroupGuid"
                          >
                            {{ occupationGroup }}
                          </option>
                        </select2>
                      </div>
                      <span
                        v-show="inputHasError('inputShopperOccupationGroup')"
                        class="help-block error text-danger"
                        >{{ lang.SM1009 }}</span
                      >
                    </div>
                    <div class="form-group">
                      <label
                        for="inputShopperOccupation"
                        class="col-md-3 control-label"
                      >
                        {{ lang.SM1021 }}
                        <span v-if="feature.isAudiTarget">*</span>
                      </label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperOccupation"
                          v-model="editShopperData.Occupation"
                          :required="feature.isAudiTarget"
                        />
                        <span
                          v-show="inputHasError('inputShopperOccupation')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group" v-if="!feature.isAudiTarget">
                      <label
                        for="inputShopperEmployer"
                        class="col-md-3 control-label"
                        >{{ lang.SM1022 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperEmployer"
                          v-model="editShopperData.Employer"
                        />
                        <span
                          v-show="inputHasError('inputShopperEmployer')"
                          class="help-block error text-danger"
                          >{{ lang.SM1009 }}</span
                        >
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        editShopperData.ShopperGuid && !feature.isAudiTarget
                      "
                    >
                      <label
                        for="inputShopperVatNo"
                        class="col-md-3 control-label"
                        >{{ lang.SM1041 }} *</label
                      >
                      <div class="col-md-4">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperVatNo"
                          disabled
                          v-model="editShopperData.VatNo"
                        />
                      </div>
                      <div class="col-md-5">
                        <div class="checkbox" style="float: left">
                          <label>
                            <input
                              type="checkbox"
                              v-model="editShopperData.VatNotMandatory"
                              disabled
                            />
                            <span class="checkbox-material">
                              <span class="check"></span>
                            </span>
                            <span class="text text-black">{{
                              lang.SM1042
                            }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group"
                      v-if="
                        editShopperData.SocialSecurityNumber &&
                        !feature.isAudiTarget
                      "
                    >
                      <label
                        for="inputShopperSocialSecurityNumber"
                        class="col-md-3 control-label"
                        >{{ lang.SM1043 }} *</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputShopperSocialSecurityNumber"
                          v-model="editShopperData.SocialSecurityNumber"
                          disabled
                        />
                      </div>
                    </div>
                    <!-- Geocode -> -->
                    <div class="form-group" v-if="!dialogModeAdd">
                      <label for="inputLatitude" class="col-md-3 control-label">{{ lang.L0044 }}</label>
                      <div class="col-md-9">
                        <input
                          type="number"
                          step="any"
                          min="-90"
                          max="90"
                          class="form-control"
                          id="inputLatitude"
                          v-model="editShopperData.Latitude"
                          @input="validateInput('inputLatitude')"
                        />
                        <span v-show="inputHasError('inputLatitude')" class="help-block error text-danger">{{ lang.L0083 }}</span>
                      </div>
                    </div>
                    <div class="form-group" v-if="!dialogModeAdd">
                      <label for="inputLongitude" class="col-md-3 control-label">{{ lang.L0045 }}</label>
                      <div class="col-md-9">
                        <input
                          type="number"
                          step="any"
                          min="-180"
                          max="180"
                          class="form-control"
                          id="inputLongitude"
                          v-model="editShopperData.Longitude"
                          @input="validateInput('inputLongitude')"
                        />
                        <span v-show="inputHasError('inputLongitude')" class="help-block error text-danger">{{ lang.L0083 }}</span>
                      </div>
                    </div>
                    <div class="form-group" v-if="!dialogModeAdd">
                      <label for="inputGeocodeSource" class="col-md-3 control-label">{{ lang.L0046 }}</label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputGeocodeSource"
                          v-model="editShopperData.GeocodeSource"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- <- Geocode -->
                </div>
                <!-- Accordion entry 2 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingBankDetails"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseBankDetails"
                  aria-expanded="true"
                  aria-controls="collapseBankDetails"
                  v-if="
                    !dialogModeAdd &&
                    globals.isAccessAllowed('LoopOp_ShopperBankDetails_ReadAll')
                  "
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.SM1035 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseBankDetails"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingBankDetails"
                  v-if="
                    !dialogModeAdd &&
                    globals.isAccessAllowed('LoopOp_ShopperBankDetails_ReadAll')
                  "
                >
                  <div class="panel-body">
                    <div class="form-group">
                      <label
                        for="inputBankDetailsBankName"
                        class="col-md-3 control-label"
                        >{{ lang.SM1036 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputBankDetailsBankName"
                          v-model="bankDetailsData.BankName"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputBankDetailsSwiftCode"
                        class="col-md-3 control-label"
                        >{{ lang.SM1037 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputBankDetailsSwiftCode"
                          v-model="bankDetailsData.SwiftCode"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputBankDetailsAccountNumber"
                        class="col-md-3 control-label"
                        >{{ lang.SM1038 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputBankDetailsAccountNumber"
                          v-model="bankDetailsData.AccountNumber"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputBankDetailsAccountName"
                        class="col-md-3 control-label"
                        >{{ lang.SM1039 }}</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          class="form-control"
                          id="inputBankDetailsAccountName"
                          v-model="bankDetailsData.AccountName"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Accordion entry 3 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingCustomProperties"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseCustomProperties"
                  aria-expanded="true"
                  aria-controls="collapseCustomProperties"
                  v-if="
                    globals.isAccessAllowed(
                      'LoopOp_ShopperProperties_Shopper_Read'
                    )
                  "
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.SM1040 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseCustomProperties"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingCustomProperties"
                  v-if="
                    globals.isAccessAllowed(
                      'LoopOp_ShopperProperties_Shopper_Read'
                    )
                  "
                >
                  <div class="panel-body">
                    <custom-properties-form
                      ref="customPropertiesForm"
                      :shopperGuid="selectedShopperGuid"
                    ></custom-properties-form>
                  </div>
                </div>
                <!-- Accordion entry 4 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingShopperAdministration"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseShopperAdministration"
                  aria-expanded="true"
                  aria-controls="collapseShopperAdministration"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.SM1044 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseShopperAdministration"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingShopperAdministration"
                >
                  <div class="panel-body">
                    <div
                      class="form-group"
                      v-if="editShopperData.MigratedShopperId"
                    >
                      <label class="col-md-2 control-label">{{
                        lang.SM1052
                      }}</label>
                      <div class="col-md-10">
                        <label class="form-control text-left">{{
                          editShopperData.MigratedShopperId
                        }}</label>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="selectShopperAccountStatus"
                        class="col-md-2 control-label"
                        >{{ lang.SM1045 }}</label
                      >
                      <div class="col-md-10">
                        <select
                          class="form-control"
                          id="selectShopperAccountStatus"
                          v-model="editShopperData.Active"
                        >
                          <option :value="true">{{ lang.SM1046 }}</option>
                          <option :value="false">{{ lang.SM1047 }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="selectShopperSkillLevel"
                        class="col-md-2 control-label"
                        >{{ lang.SM1049 }}</label
                      >
                      <div class="col-md-10">
                        <select
                          class="form-control"
                          id="selectShopperSkillLevel"
                          v-model.number="editShopperData.ShopperSkillLevel"
                          :disabled="!globals.isSkillLevelEditingAllowed"
                        >
                          <option v-for="i in 5" :key="i">{{ i }}</option>
                        </select>
                      </div>
                      <b-tooltip
                        target="selectShopperSkillLevel"
                        :delay="globals.tooltipDelay"
                        placement="right"
                        boundary="viewport"
                      >
                        1 &rarr; {{ lang.SM1050 }}
                        <br />
                        <br />...
                        <br />
                        <br />
                        5 &rarr; {{ lang.SM1051 }}
                      </b-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.SM1007 }}
            </button>
            <button
              id="shopper-management-save-button-modal"
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="validateBeforeSubmit('editShopperDialog')"
              :disabled="!globals.isAccessAllowed('LoopOp_Shopper_Update')"
            >
              {{ lang.SM1008 }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";
import CustomPropertiesForm from "./CustomPropertiesForm";

export default {
  name: "ShopperDataEditModal",
  components: {
    Select2,
    CustomPropertiesForm,
  },
  mounted() {
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    }

    $("#editShopperDialog").on("hide.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    this.fpBirthdate = flatpickr(
      "#inputShopperBirthdate",
      this.globals.flatpickrDateConfig
    );
  },
  destroyed() {
    if (this.fpBirthdate) this.fpBirthdate.destroy();
  },
  props: [
    "showDialog",
    "occupationalGroupList",
    "dialogModeAdd",
    "selectedShopperGuid",
  ],
  watch: {
    showDialog() {
      this.showDialog
        ? this.openEditShopperDialog()
        : this.closeEditShopperDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    },
  },
  data() {
    return {
      dialogTitle: "",
      invalidInputIds: [],
      fpBirthdate: null,
      profilePictureFileObject: {},
      shopperPicture: {
        fileGuid: "",
        fileName: "",
      },
      editShopperData: {
        Active: true,
        ShopperSkillLevel: 3,
        Salutation: "",
        FirstName: "",
        LastName: "",
        Address1: "",
        PostalCode: "",
        City: "",
        CountryCode: "",
        Birthdate: "",
        Email: "",
        Phone1: "",
        Phone2: "",
        OccupationalGroupGuid: "", // Berufsgruppe
        Occupation: "", // Tätig als
        Employer: "", // Tätig bei
        Gender: "",
        // VatNo: "",
        ProfilePictureGuid: "",
      },
      bankDetailsData: {},
      lang: {
        SM1000: "New Shopper",
        SM1001: "Edit Shopper",
        SM1002: "Shopper Information",
        SM1003: "Salutation", // form of adress
        SM1004: "Please select...",
        SM1005: "Madam",
        SM1006: "Monsieur",
        SM1007: "Close",
        SM1008: "Save",
        SM1009: "This is a required entry!",
        SM1010: "First name",
        SM1011: "Last name",
        SM1012: "Street",
        SM1013: "Postal Code",
        SM1014: "City",
        SM1015: "Country",
        SM1016: "Birthday",
        SM1017: "Email",
        SM1018: "Phone",
        SM1019: "Alternative Phone",
        SM1020: "Career",
        SM1021: "Profession",
        SM1022: "Active by",
        SM1023: "Got attention by",
        SM1024: "Picture",
        SM1025: "Please choose a picture...",
        SM1026: "Choose picture",
        SM1027: "Download picture",
        SM1028: "Delete picture",
        SM1029: "Gender",
        SM1030: "Male",
        SM1031: "Female",
        SM1032: "VAT No.",
        SM1033: "Divers",
        SM1034: "Form validation failed",
        SM1035: "Bank Details",
        SM1036: "Bank Name",
        SM1037: "BIC",
        SM1038: "IBAN",
        SM1039: "Account owner",
        SM1040: "Custom Properties",
        SM1041: "VAT No.",
        SM1042: "VAT not mandatory",
        SM1043: "Social security number",
        SM1044: "Administration",
        SM1045: "Account status",
        SM1046: "Activated",
        SM1047: "Deactivated",
        SM1048: "Username",
        SM1049: "Experience level",
        SM1050: "simple projects",
        SM1051: "difficult projects",
        SM1052: "Previous Shopper ID",

        
        L0044: "Breitengrad",
        L0045: "Längengrad",
        L0046: "Geocode Quelle",
        L0083: "Ungültiger Wert",
      },
    };
  },
  methods: {
    openEditShopperDialog() {
      this.bankDetailsData = {};
      if (this.dialogModeAdd) {
        this.dialogTitle = this.lang.SM1000;
        this.initEditShopperDialog();
        if (this.$refs.customPropertiesForm)
          this.$nextTick(() => {
            this.$refs.customPropertiesForm.getShopperProperties(
              () => {
                $("#editShopperDialog").modal("show");
              },
              () => {
                this.globals.showErrorSnackbar(
                  "Shopper property data request failed"
                );
                this.$emit("dialogClosed");
              }
            );
          });
      } else {
        this.dialogTitle = this.lang.SM1001;
        let requestCount = 3;
        let successCallback = () => {
          if (--requestCount < 1) {
            $("#editShopperDialog").modal("show");
            this.resetValidationErrors("editShopperDialog");
          }
        };
        let errorCallback = () => {
          this.globals.showErrorSnackbar("Shopper data request failed");
          this.$emit("dialogClosed");
        };
        this.getSelectedShopper(successCallback, errorCallback);
        this.getBankDetails(successCallback, errorCallback);

        if (this.$refs.customPropertiesForm)
          this.$refs.customPropertiesForm.getShopperProperties(
            successCallback,
            errorCallback
          );
        else successCallback();
      }
      this.resetValidationErrors("editShopperDialog");
    },
    getSelectedShopper(success, error) {
      let queryString = `api/Shopper/${this.selectedShopperGuid}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.editShopperData = data;
          if (!this.editShopperData.Salutation)
            this.editShopperData.Salutation = "";
          if (this.editShopperData.Birthdate)
            this.fpBirthdate.setDate(this.editShopperData.Birthdate);
          success();
        },
        error: () => {
          console.error("Error on GET in getSelectedShopper()");
          error();
        },
      });
    },
    closeEditShopperDialog() {
      $("#editShopperDialog").modal("hide");
    },
    initEditShopperDialog() {
      let fieldsToRemove = [
        "Username",
        "ShopperGuid",
        "ShopperId",
        "VatNo",
        "VatNotMandatory",
        "Active",
        "MigratedShopperId",
      ];
      Object.keys(this.editShopperData).forEach((key) => {
        fieldsToRemove.indexOf(key) < 0
          ? (this.editShopperData[key] = "")
          : delete this.editShopperData[key];
      });
      this.editShopperData.Active = true;
      this.editShopperData.ShopperSkillLevel = 3;
      this.fpBirthdate.clear();
    },
    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit(dialog) {
      var result = true;
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }
      if (dialog === "editShopperDialog") {
        if (!result) {
          this.globals.showErrorSnackbar(this.lang.SM1034);
          return;
        }
        this.saveEditShopperData();
      }
    },
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput(id) {
      // Checks validation depending on the input type or a given pattern in the template
      var result =
        id === "inputShopperBirthdate"
          ? $("#" + id)[0].value !== ""
          : $("#" + id)[0].checkValidity();
      if (result) {
        $("#" + id)
          .parent()
          .parent()
          .removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id)
          .parent()
          .parent()
          .addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },
    // Returns true if an input has a validation error, otherwise false
    inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },
    // Resets all validation errors for the given dialog
    resetValidationErrors(dialog) {
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          $("#" + elements[i].id)
            .parent()
            .parent()
            .removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    cleanUpEmptyData() {
      for (let prop in this.editShopperData)
        if (
          typeof this.editShopperData[prop] === "string" &&
          !this.editShopperData[prop]
        )
          delete this.editShopperData[prop];
    },
    saveEditShopperData() {
      this.cleanUpEmptyData();
      let queryString = "api/Shopper";
      let reqMethod = "POST";

      if (!this.dialogModeAdd) {
        queryString += `/${this.selectedShopperGuid}`;
        reqMethod = "PUT";
      } else this.editShopperData.Active = true;

      if (!this.editShopperData.ProfilePictureGuid)
        delete this.editShopperData.ProfilePictureGuid;

      let requestCount = 2;
      let successCallback = () => {
        if (--requestCount < 1) {
          let successMsg = this.dialogModeAdd
            ? "Shopper creation successful"
            : "Shopper update successful";
          this.globals.showSuccessSnackbar(successMsg);
          this.closeEditShopperDialog();
          this.$emit("dialogDataSaved");
        }
      };
      let errorCallback = () => {
        let errorMsg = this.dialogModeAdd
          ? "Shopper creation failed"
          : "Shopper update failed";
        this.globals.showErrorSnackbar(errorMsg);
      };

      if (this.$refs.customPropertiesForm) {
        let custPropData = this.$refs.customPropertiesForm.saveShopperProperties(
          successCallback,
          errorCallback
        );
        if (custPropData && custPropData.Properties) {
          requestCount--;
          if (custPropData.Properties[0])
            this.editShopperData.Properties = custPropData.Properties;
        }
      }

      $.ajax({
        method: reqMethod,
        url: queryString,
        data: JSON.stringify(this.editShopperData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          successCallback();
        },
        error: () => {
          console.error(`Error on ${reqMethod} in saveEditShopperData()`);
          errorCallback();
        },
      });
    },
    onShopperProfilePictureFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) {
        this.editShopperData.ProfilePictureGuid = "";
        this.profilePictureFileObject = {};
        return;
      }
      this.profilePictureFileObject = files[0];
      if (this.profilePictureFileObject.type.indexOf("image/") < 0) {
        this.globals.showErrorSnackbar("Invalid file type");
        e.target.value = null;
        return;
      }

      let callback = () => {
        let uploadSuccess = (data) => {
          this.editShopperData.ProfilePictureGuid = data[0].DownloadId;
          this.editShopperData.ProfilePictureFileName = this.profilePictureFileObject.name;
          this.globals.showSuccessSnackbar("Profile picture upload successful");
          this.$forceUpdate();
        };

        this.globals.uploadFile(this.profilePictureFileObject, uploadSuccess);
        e.target.value = null;
      };

      this.profilePictureFileObject.imageUrl = URL.createObjectURL(
        this.profilePictureFileObject
      );
      this.globals.getImageOrientation(
        this.profilePictureFileObject,
        (orientation) => {
          this.globals.resetImageOrientation(
            this.profilePictureFileObject,
            orientation,
            (data) => {
              this.profilePictureFileObject = data;
              callback();
            }
          );
        }
      );
    },
    removeShopperProfilePictureFile() {
      $("#inputShopperProfilePictureFile")[0].value = null;
      this.editShopperData.ProfilePictureGuid = "";
      this.editShopperData.ProfilePictureFileName = "";
      this.profilePictureFileObject = {};
      this.$forceUpdate();
    },
    getBankDetails(success, error) {
      if (!this.globals.isAccessAllowed("LoopOp_ShopperBankDetails_ReadAll")) {
        success();
        return;
      }

      let queryString = `api/Shopper/${this.selectedShopperGuid}/BankDetails`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data) {
            if (!_.isEmpty(data)) {
              this.bankDetailsData = data[0];
            } else {
              this.bankDetailsData = {};
            }
            success();
          } else error();
        },
        error: () => {
          console.error("Error on GET in getBankDetails()");
          this.bankDetailsData = {};
          error();
        },
      });
    },
    //TODO: bank details are readonly for now but later it might be necessary to change values for MSM users
    // saveBankDetails(success, error) {
    //   let queryString = `api/Shopper/${this.selectedShopperGuid}/BankDetails`;
    //   let reqMethod = "POST";
    //   if (this.bankDetailsData.BankDetailsGuid) {
    //     queryString += "/" + this.bankDetailsData.BankDetailsGuid;
    //     reqMethod = "PUT";
    //   }

    //   $.ajax({
    //     method: reqMethod,
    //     url: queryString,
    //     data: JSON.stringify(this.bankDetailsData),
    //     dataType: "json",
    //     contentType: "application/json; charset=utf-8",
    //     success: data => {
    //       if (data && !_.isEmpty(data)) {
    //         this.bankDetailsData = data;
    //       }
    //       success();
    //     },
    //     error: () => {
    //       console.error("Error on PUT in saveProfileData()");
    //       error();
    //     }
    //   });
    // },
    openFileSelector() {
      $("#inputShopperProfilePictureFile").click();
    },
  },
};
</script>

<style scoped>
.form-group-files {
  padding: 2px 0;
  overflow: hidden;
}

.noclearfix {
  clear: none !important;
}

#profilePictureContainer > img {
  height: 180px;
  width: 180px;
  object-fit: contain;
  cursor: pointer;
}

#removeProfilePictureButton {
  position: absolute;
  top: 0px;
  right: 0px;
  color: rgb(224, 0, 0);
  background: white;
  opacity: 0.7;
  width: 36px;
  height: 36px;
  border-radius: 18px;
  text-decoration: none;
}
#removeProfilePictureButton > i {
  font-size: 36px;
  font-weight: bold;
}

.panel-heading > .panel-title > a.collapsed {
  text-decoration: none;
  color: inherit;
}

#shopperEditForm span.help-block.error {
  z-index: 5000;
}

#collapseGeneral .checkbox .text {
  position: relative;
  top: 2px;
  left: 2px;
}

#collapseGeneral .form-group {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// ShopperEditModal.vue?1197f096